import { CouponCheckout } from 'routes/client/routes/Checkout/Coupon'

export default CouponCheckout
